export const encodeBody = (obj, prefix = null, encode = true) =>
  Object.entries(obj)
    .map(([key, value]) => {
      const fullKey = prefix ? `${prefix}[${key}]` : key;
      if (encode) {
        return value !== null && typeof value === "object"
          ? encodeBody(value, fullKey)
          : encodeURIComponent(fullKey) + "=" + encodeURIComponent(value);
      } else {
        return value !== null && typeof value === "object"
          ? encodeBody(value, fullKey)
          : fullKey + "=" + value;
      }
    })
    .filter(a => !!a)
    .join("&");

export class Request {
  constructor(props) {
    Object.assign(this, props);
  }

  setHost(host) {
    this.host = host;
    return this;
  }

  setEndpoint(endpoint) {
    this.endpoint = endpoint;
    return this;
  }

  setMethod(method) {
    this.method = method;
    return this;
  }

  setHeader(name, value) {
    this.headers = Object.assign(this.headers || {}, { [name]: value });
    return this;
  }

  setAuthKey(key) {
    return this.setHeader("Authorization", key);
  }

  setFormat(format, mime) {
    this.format = format;
    return this.setHeader("Accept", mime).setHeader("Content-Type", mime);
  }

  setFormatJson() {
    return this.setFormat("json", "application/json");
  }

  setFormatXml() {
    return this.setFormat("xml", "text/xml");
  }

  setUrlParams(params) {
    this.urlParams = params;
    return this;
  }

  setBody(body) {
    this.body = body;
    return this;
  }

  makeUrlParamsPart() {
    const params = this.urlParams || {};
    if (this.format) {
      params["_format"] = this.format;
    }
    return Object.entries(params)
      .map(([key, val]) => {
        return `${key}=${val}`;
      })
      .join("&");
  }

  makeUrl() {
    const host = (this.host || "").replace(/\/*$/g, "");
    const endpoint = (this.endpoint || "").replace(/^\/*|\/*$/g, "");
    const params = this.makeUrlParamsPart();
    return host + (endpoint && "/") + endpoint + (params && "?") + params;
  }

  _getFetchOptions() {
    const options = {};
    if (this.method) {
      options.method = this.method;
    }
    if (this.body) {
      options.body = this.body;
    }
    if (this.headers) {
      options.headers = this.headers;
    }

    return options;
  }

  fetch() {
    return fetch(this.makeUrl(), this._getFetchOptions());
  }

  fetchStatus() {
    return this.fetch().then(({ ok }) => ok);
  }

  fetchJson() {
    return this.fetch().then(res => res.json());
  }

  setEncodedBody(params) {
    return this.setHeader(
      "Content-Type",
      "application/x-www-form-urlencoded;charset=UTF-8"
    ).setBody(encodeBody(params));
  }
}

export class Client {
  constructor(props) {
    Object.assign(this, props);
  }
  getRequest() {
    return new Request({ host: this.host });
  }

  getNews(params = {}) {
    return this.getRequest()
      .setEndpoint("/v1/articles")
      .setMethod("GET")
      .setUrlParams(params);
  }

  getArticle(id,params = {}) {
    return this.getRequest()
      .setEndpoint(`/v1/articles/${id}`)
      .setMethod("GET")
      .setUrlParams(params);
  }

  getCarousels(params = {}) {
    return this.getRequest()
      .setEndpoint("/v1/widget-carousels")
      .setMethod("GET")
      .setUrlParams(params);
  }

  getWidgetText(params) {
    return this.getRequest()
      .setEndpoint("/v1/widget-text")
      .setMethod("GET")
      .setUrlParams(params);
  }

  getStatistic(params) {
    return this.getRequest()
      .setEndpoint("/v1/statistic")
      .setMethod("GET")
      .setUrlParams(params);
  }
  getStatisticDates(params) {
    return this.getRequest()
      .setEndpoint("/v1/statistic/dates")
      .setMethod("GET")
      .setUrlParams(params);
  }
  getReports(params = {}) {
    return this.getRequest()
      .setEndpoint("/v1/reports")
      .setMethod("GET")
      .setUrlParams(params);
  }
  getReportsByDay(params = {}) {
    return this.getRequest()
      .setEndpoint("/v1/reports/by-day")
      .setMethod("GET")
      .setUrlParams(params);
  }
  updateReports(reports = []) {
    return this.getRequest()
      .setEndpoint("/v1/reports/update")
      .setMethod("POST")
      .setEncodedBody({reports})
  }
}

export default new Client({ host: process.env.REACT_APP_BACKEND_HOST });



// WEBPACK FOOTER //
// ./src/BackendClient.js